export const DRIVER_TIPPING = {
  NOT_NOW: 'Not Now',
  OTHERS: 'Other',
  COMPOSITE: 'composite',
  ABSOLUTE: 'absolute',
  PERCENTAGE: 'percentage',
  VALUE: 'value',
};
